import { CURRENT_CLIENT } from '@/constants'

export const YESHUMAN_CONCEPTS_PATH = '/concepts'
export const YESHUMAN_CONCEPTS_TOPOLOGY_PATH = '/concepts/topology'

const CONCEPTS_LANDING_COMPONENT = 'yeshumanWorkbench'

function configuredLandingComponent(): string | undefined {
  return (CURRENT_CLIENT as { landing?: { landingComponent?: string } }).landing?.landingComponent
}

/** Concepts pages belong to the Yes Human workbench landing — public, no agent shell. */
export function isYeshumanConceptsPath(
  pathname: string,
  landingComponent: string | undefined = configuredLandingComponent(),
): boolean {
  if (landingComponent !== CONCEPTS_LANDING_COMPONENT) return false
  const path = pathname || '/'
  return path === YESHUMAN_CONCEPTS_PATH || path === YESHUMAN_CONCEPTS_TOPOLOGY_PATH
}
